import "./css/tailwindcss.css";
import "./css/normalize.css";
import "remixicon/fonts/remixicon.css";
import "./css/projects.scss";

import '@wordpress/block-library/build-style/style.css';
import '@wordpress/block-library/build-style/theme.css';
import "./css/main.css";

import "./page/head.js";
import "./page/lazy-load.js";
import "./page/ai.js";